import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMissedCall = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			width: 40,
			height: 40,
			rx: 20,
			fill: "#FEF2F2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25.4471 13.6811L28.1283 11L28.8943 11.766L26.2132 14.4472L28.8943 17.1282L28.1283 17.8943L25.4471 15.2132L22.766 17.8943L22 17.1282L24.6811 14.4472L22 11.766L22.766 11L25.4471 13.6811Z",
			fill: "#DC2626"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29 24.42V27.9561C29 28.4811 28.5941 28.9167 28.0705 28.9537C27.6331 28.9846 27.2763 29 27 29C18.1634 29 11 21.8366 11 13C11 12.7237 11.0155 12.3669 11.0464 11.9295C11.0834 11.4059 11.5189 11 12.0439 11H15.5801C15.8368 11 16.0518 11.1944 16.0775 11.4498C16.1007 11.6791 16.1222 11.8631 16.1421 12.002C16.3443 13.4147 16.7575 14.7594 17.3487 16.003C17.4436 16.2026 17.3817 16.4416 17.2018 16.5701L15.0436 18.1118C16.3575 21.1811 18.8189 23.6425 21.8882 24.9565L23.4271 22.8019C23.5572 22.6199 23.799 22.5573 24.001 22.6532C25.2446 23.2439 26.5891 23.6566 28.0016 23.8584C28.1396 23.8782 28.3225 23.8995 28.5502 23.9225C28.8056 23.9483 29 24.1633 29 24.42Z",
			fill: "#DC2626"
		})
	]
});
const ForwardRef = forwardRef(SvgMissedCall);
export { ForwardRef as ReactComponent };
